import {AuthOTPAction, ADD_USERNAME, ADD_SECURITY_CODE } from "./types";

export function addUserName(username: string): AuthOTPAction {
    return {
        type: ADD_USERNAME,
        payload: username
    }
}

export function addSecurityCode(securityCode: string): AuthOTPAction {
    return {
        type: ADD_SECURITY_CODE,
        payload: securityCode
    }
}
